import { render, staticRenderFns } from "./SharingEntryInherited.vue?vue&type=template&id=a332eb2c&scoped=true"
import script from "./SharingEntryInherited.vue?vue&type=script&lang=js"
export * from "./SharingEntryInherited.vue?vue&type=script&lang=js"
import style0 from "./SharingEntryInherited.vue?vue&type=style&index=0&id=a332eb2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a332eb2c",
  null
  
)

export default component.exports